// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"25":"d0448a6e","72":"2ae95184","91":"8fcce4ce","109":"c73d6688","122":"0eb43362","297":"7e727c79","309":"9addc6d4","325":"7f767708","374":"9e08490d","387":"3517e064","531":"30529555","562":"9297b879","581":"8fc21429","981":"ffef9dce","995":"de969282"}[chunkId] + ".chunk.js";
};